import {Navigate, useLocation} from "react-router-dom";
import {RoutePaths} from "../../../../util/constants";
import {ReactElement} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../../store";

type Props = {
    showRoute: boolean;
    redirectTo?: RoutePaths;
    children: ReactElement;
};

export default function ProtectedRoute({
                                           showRoute,
                                           redirectTo = RoutePaths.HOME,
                                           children,
                                       }: Props) {
    const location = useLocation();
    const appLoading = useSelector((state: RootState) => state.appReducer.appLoading)
    const locationState = location.state && typeof location.state === "object"
        ? location.state as Record<string, unknown>
        : null;

    // Extract redirect target from router state (preferred) or query param (backward compatible).
    const stateRedirect = typeof locationState?.redirectTo === "string" ? locationState.redirectTo : undefined;
    const params = new URLSearchParams(location.search);
    const redirectParam = params.get("redirect");

    const normalizeRedirect = (value?: string | null): string | null => {
        if (!value) return null;
        const trimmed = value.trim();
        if (!trimmed.startsWith("/") || trimmed.startsWith("//")) {
            return null;
        }
        return trimmed;
    };

    const finalRedirect = normalizeRedirect(stateRedirect) || normalizeRedirect(redirectParam) || redirectTo;
    const forwardedState = locationState
        ? Object.fromEntries(Object.entries(locationState).filter(([key]) => key !== "redirectTo"))
        : null;
    const hasForwardedState = !!forwardedState && Object.keys(forwardedState).length > 0;

    return showRoute || appLoading
        ? children
        : <Navigate to={finalRedirect} replace state={hasForwardedState ? forwardedState : undefined}/>;
}
